<template>
  <div>
    <el-dialog
      :title="Title"
      :visible="MakeEditDialogFormVisible"
      @close="HandleEditDialogClose"
      @open="HandleEditDialogOpen"
    >
      <el-row>
        <el-form
          :model="editTaskform"
          :rules="formRules"
          ref="editTaskform"
          label-position="left"
          label-width="auto"
          class="demo-ruleForm"
        >
          <el-form-item label="Descripción" prop="description">
            <el-input
              size="large"
              type="textarea"
              v-model="editTaskform.description"
              :rows="1"
              placeholder="Ingrese la descripción de la tarea"
            ></el-input>
          </el-form-item>
          <el-row class="mb-100">
            <el-form-item label="Detalles" prop="details">
              <quillEditor
                style="height: 100px"
                ref="myQuillEditor"
                v-model="editTaskform.details"
              />
            </el-form-item>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="Responsable" prop="responsible">
                <EmployeeSelector
                  size="large"
                  :CurrentEmployee="editTaskform.responsible"
                  placeholder="Responsable"
                  @selection-change="OnResponsibleSelected"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Tiempo Estimado" prop="time">
                <!-- <el-input-number
                size="large"
                v-model="form.Time"
                :min="0"
                :controls="false"
              ></el-input-number> -->
                <TimeSelector
                  :timeToEdit="editTaskform.time"
                  @TimeSelected="onTimeSelected"
                  :disabled="ViewTask"
                />
              </el-form-item>
            </el-col>

            <el-col v-if="IsTask" :span="8">
              <el-form-item label="Fijada" prop="isFixed">
                <el-checkbox v-model="editTaskform.isFixed"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="Fecha de ejecución" prop="executionDate">
                <el-date-picker
                  v-model="editTaskform.executionDate"
                  type="date"
                  placeholder="Seleccione una fecha"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col v-if="IsClosed" :span="8">
              <el-form-item label="Fecha de cierre" prop="closureDate">
                <el-date-picker
                  v-model="editTaskform.closureDate"
                  type="date"
                  placeholder="Seleccione una fecha"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="HandleEditDialogClose">Cancel</el-button>
        <el-button type="primary" @click="HandleEditDialogSubmmit"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import EmployeeSelector from "@/components/Company/EmployeeSelector";
import TimeSelector from "@/components/cmi/ObjectivesReport/TimeSelector";

export default {
  name: "EditTaskForm",
  components: {
    quillEditor,
    EmployeeSelector,
    TimeSelector
  },
  props: {
    editDialogFormVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    ViewTask: {
      type: Boolean,
      default: false
    },
    ActualTaskInfo: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  data() {
    return {
      editTaskform: {
        description: "",
        details: "",
        responsible: 0,
        originalId: 0,
        taskId: "",
        time: 0,
        executionDate: "",
        closureDate: "",
        isFixed: false
      },
      formRules: {
        description: [
          {
            required: true,
            message: "La descripción es requerida",
            trigger: "blur"
          }
        ],
        details: [
          {
            required: true,
            message: "Los detalles son requeridos",
            trigger: "blur"
          }
        ],
        responsible: [
          {
            required: true,
            message: "El responsable es requerido",
            trigger: "change"
          }
        ],
        executionDate: [
          {
            required: true,
            message: "La fecha de ejecución es requerida",
            trigger: "change"
          }
        ],
        closureDate: [
          {
            required: false,
            message: "La fecha de cierre es requerida",
            trigger: "change"
          }
        ],
        isFixed: [
          {
            required: false,
            message: "El estado de fijación es requerido",
            trigger: "change"
          }
        ]
      },
      formLabelWidth: "120px"
    };
  },
  computed: {
    MakeEditDialogFormVisible() {
      return this.editDialogFormVisible;
    },
    TaskInfo() {
      return this.ActualTaskInfo || {};
    },
    TaskId() {
      return this.TaskInfo.ID || "";
    },
    IsTask() {
      return this.TaskId.includes("T-");
    },
    IsInternalRequest() {
      return this.TaskId.includes("SI-");
    },
    IsExternalRequest() {
      return this.TaskId.includes("SE-");
    },
    IsClosed() {
      return !!this.TaskInfo.IsItClosed;
    },
    Title() {
      let title = "";
      if (this.IsTask) {
        title = `Editar Tarea Número: ${this.TaskInfo._ID}`;
      } else if (this.IsInternalRequest) {
        title = `Editar Solicitud Interna Número: ${this.TaskInfo._ID}`;
      } else if (this.IsExternalRequest) {
        title = `Editar Solicitud Externa Número: ${this.TaskInfo._ID}`;
      } else {
        title = "Editar Tarea";
      }
      return title;
    }
  },
  mounted() {},

  methods: {
    HandleEditDialogClose() {
      if (this.$refs.editTaskform) {
        this.$refs.editTaskform.resetFields();
      }
      this.$emit("update:editDialogFormVisible", false);
      this.$emit("OnEditDialogFormCloses", false);
    },
    HandleEditDialogOpen() {
      this.editTaskform.description = this.TaskInfo.Name || "";
      this.editTaskform.details = this.TaskInfo.Descripcion || "";
      this.editTaskform.responsible = this.TaskInfo.ResponsableID || 0;
      this.editTaskform.time = this.TaskInfo.TimeOntask || 0;
      this.editTaskform.originalId = this.TaskInfo.OriginalID || 0;
      this.editTaskform.taskId = this.TaskInfo.ID || 0;
      this.editTaskform.executionDate = this.TaskInfo.ExecutionDate || "";
      this.editTaskform.closureDate = this.TaskInfo.CloseDate || "";
      this.editTaskform.isFixed = this.TaskInfo.IsFixed || false;
    },
    HandleEditDialogSubmmit() {
      this.$refs.editTaskform.validate(async (valid) => {
        if (valid) {
          await this.$http
            .put(`api/ReporteGestion/UpdateTask`, this.editTaskform)
            .then(() => {
              this.$message.success("Tarea actualizada exitosamente");
              this.HandleEditDialogClose();
              this.$emit("OnTaskUpdated");
            })
            .catch((error) => {
              console.error("Error updating task:", error);
              this.$message.error("Error al actualizar la tarea");
            });
        } else {
          this.$message.error(
            "Faltan campos por completar o son inválidos. Por favor, revise el formulario."
          );
          return false;
        }
      });
    },
    onTimeSelected(time) {
      this.editTaskform.time = time;
    },
    OnResponsibleSelected(responsible) {
      this.editTaskform.responsible = responsible;
    }
  },
  watch: {
    // MakeEditDialogFormVisible(newVal) {
    //   // this.$emit('update:editDialogFormVisible', newVal);
    //   // this.$refs.editTaskform.resetFields();
    // }
  }
};
</script>

<style scoped></style>
